import { RegisterForm } from '../register.interface'

export const getRegisterInitialValues = (form?: Partial<RegisterForm>) => {
  if (form) {
    return {
      fio: form.fio ?? null,
      email: form.email ?? null,
      password: form.password ?? null,
      passwordConfirm: form.passwordConfirm ?? null,
      companyName: form.companyName ?? null,
      companyInn: form.companyInn ?? null,
      companyOgrn: form.companyOgrn ?? null,
    }
  }

  return {
    fio: null,
    email: null,
    password: null,
    passwordConfirm: null,
    companyName: null,
    companyInn: null,
    companyOgrn: null,
  }
}
